export const serialize = (obj, prefix) => {
  var str = [], p;

  for(p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }

  return str.join("&");
};

export const sendData = (
  data,
  url,
  contentType = 'application/x-www-form-urlencoded'
) => {
  let xhr;

  const promise = new Promise((resolve, reject) => {
    xhr = new XMLHttpRequest();
    xhr.open('post', url, true);
    xhr.setRequestHeader('Content-type', contentType);
    // xhr.responseType = 'json';

    xhr.onload = function() {
      var status = xhr.status;
      status === 200 ? resolve(xhr.response) : reject(status);
    };

    xhr.send(data);
  });

  promise.cancel = () => xhr.abort();

  return promise;
};

export const saveState = (state) => {
  console.log('saving...');
  
  let ajaxurl = ajax_object.ajax_url;
  let promise;

  if (typeof ajaxurl === 'undefined') {
    /**
     * App is running outside of the Jupiter env.
     * Simulating the sendData behavior.
     */
    let id;
    promise = new Promise((resolve) => {
      id = setTimeout(resolve, 1000);
    });
    promise.cancel = () => {
      clearTimeout(id);
      console.log('cacelled!');
    };
  } else {
    promise = sendData(serialize({
      action: 'abb_header_builder_store_data',
      fn_data: JSON.stringify(state)
    }), ajaxurl);
  }

  promise.then(() => console.log('saved.'));

  return promise;
};



// WEBPACK FOOTER //
// ./app/header-builder/fetch.js